// Megamenu open/close on hover or click with added search close logic
const toggleMegaMenu = () => {
  const inlineMenu = document.querySelector(".header__inline-menu")
  const detailsItems = inlineMenu.querySelectorAll("details")
  const searchDetails = document.querySelector(".header__search details")

  // Function to toggle the class for opening the mega menu
  const toggleMegaMenuClass = isOpen => {
    document.body.classList.toggle("mega-menu-opened", isOpen)
  }

  // Function to close the search menu
  const closeSearchMenu = () => {
    if (searchDetails && searchDetails.open) {
      searchDetails.removeAttribute("open")
    }
  }

  // Loop through each details item in the header menu (megamenus)
  detailsItems.forEach(item => {
    let timeoutId

    // Function to open the megamenu
    const openMenu = () => {
      clearTimeout(timeoutId)
      item.setAttribute("open", "true")
      toggleMegaMenuClass(true)
    }

    // Function to close the megamenu
    const closeMenu = () => {
      timeoutId = setTimeout(() => {
        item.removeAttribute("open")
        toggleMegaMenuClass(false)
      }, 100)
    }

    const closeSearchSuggestions = () => {
      timeoutId = setTimeout(() => {
        const snizeResults = document.querySelector(".snize-ac-results")
        if (snizeResults) snizeResults.classList.add("visually-hidden")
        toggleMegaMenuClass(true)
      }, 100)
    }

    const openSearchSuggestions = () => {
      timeoutId = setTimeout(() => {
        const snizeResults = document.querySelector(".snize-ac-results")
        if (snizeResults) snizeResults.classList.remove("visually-hidden")
      }, 100)
    }

    const typingSearchSuggestions = () => {
      const snizeInput = document.querySelector(".snize-input-style")
      // Real-time typing detection
      snizeInput?.addEventListener("input", () => {
        // console.log('User is actively typing...');
        openSearchSuggestions()
      })

      // Clear state when empty
      snizeInput?.addEventListener("blur", () => {
        if (!snizeInput.value.trim()) {
          closeSearchSuggestions()
        }
      })
    }

    const searchSuggestionsCloseWhenOut = () => {
      // Click outside inlineMenu, closes Search Suggestions
      if (inlineMenu) {
        document.addEventListener("click", event => {
          // Check if click occurred outside the inline menu
          const isClickInside = inlineMenu.contains(event.target)

          if (!isClickInside) {
            const snizeResults = document.querySelector(".snize-ac-results")
            if (snizeResults) snizeResults.classList.add("visually-hidden")
          }
        })
      }
    }

    // Open and close the megamenu on hover
    item.addEventListener("mouseenter", openMenu)
    item.addEventListener("mouseleave", closeMenu)
    item.addEventListener("mouseenter", closeSearchSuggestions)
    item.addEventListener("mouseleave", typingSearchSuggestions)
    item.addEventListener("mouseleave", searchSuggestionsCloseWhenOut)

    // Handle submenu items (if any) under this header menu item
    const subMenuElement = item.querySelector("div.sub-menu-container")
    subMenuElement?.addEventListener("mouseenter", openMenu)
    subMenuElement?.addEventListener("mouseleave", closeMenu)

    // Close the search when hovering over any header menu item
    item.addEventListener("mouseenter", closeSearchMenu)
  })
}

// Initialize the megamenu functionality
document.addEventListener("DOMContentLoaded", toggleMegaMenu)
